import { render, staticRenderFns } from "./ResponseMessage.vue?vue&type=template&id=9cbf838a"
import script from "./ResponseMessage.vue?vue&type=script&lang=js"
export * from "./ResponseMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports